import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '@Root/slices'
import { fetchManagementFee, initializeState, updatePyeongNo } from '@Root/slices/myhouse/managementFee'

export default function useManagementFee() {
  const dispatch = useDispatch()
  const managementFee = useSelector((state: RootState) => state.myhouseManagementFeeSlice)

  const setPyeongNo = useCallback(
    (pyeongNo: string) => {
      dispatch(updatePyeongNo(pyeongNo))
    },
    [dispatch],
  )

  const loadManagementFee = useCallback(
    (complexNo: number) => {
      dispatch(fetchManagementFee(complexNo))
    },
    [dispatch],
  )

  const initializeManagementFee = useCallback(() => {
    dispatch(initializeState())
  }, [dispatch])

  return {
    managementFee,
    loadManagementFee,
    initializeManagementFee,
    setPyeongNo,
  }
}
